module.exports = __webpack_public_path__ + "img/argentina-25.20390c54.png";